import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import Slider from '../../components/slider';
import { Markdown } from '../../components/utils';
import { SM } from '../../config/breakpoints';

import styles from './highlight-default.module.scss';

const HighlightDefault = ({ title, text, featured, buildUrl,image,setHighlightSlug }) => {
	const [isClient, setIsClient] = useState(false);
	const isMinSM = useMediaQuery({ minWidth: SM });

	const onClick = slug => {
		setHighlightSlug(slug);
	};

	// rehydrate media queries on mounting because of SSR!
	useEffect(() => {
		setIsClient(true);
	}, []);

	const slidesToShow = (isClient && isMinSM && 3) || 2;

	return (
		<div className={styles.wrapper}>
			<h2 className={styles.title}>{title}</h2>
			{featured.length> 0 && <Slider inlineArrows={true} className={styles.slider} slidesToShow={slidesToShow}>
				{featured.map(({ slug, name, image: { childImageSharp: { fluid } } }, index) => (
					<a key={index} onClick={()=>onClick(slug)} className={styles.link}>
						<div className={styles.label}>{name}</div>
						<Img fluid={fluid} className={styles.image} />
					</a>
				))}
			</Slider>}
			{text && (
				<div className={styles.text}>
					<Markdown content={text} setHighlightSlug={setHighlightSlug} />
				</div>
			)}
			<div className={styles.imgWrapper}>
				{image?.childImageSharp?.fluid && (
					<Img className={styles.image} fluid={image.childImageSharp.fluid} alt={title} />
				  )}
			</div>
		</div>
	);
};

HighlightDefault.defaultProps = {
	text: null,
	title: null,
	featured: [],
	buildUrl: () => ''
};

HighlightDefault.propTypes = {
	title: PropTypes.string.isRequired,
	featured: PropTypes.arrayOf(
		PropTypes.shape({
			image: PropTypes.shape({
				childImageSharp: PropTypes.shape({
					fluid: PropTypes.object.isRequired
				})
			}).isRequired,
			slug: PropTypes.string.isRequired
		})
	).isRequired,
	text: PropTypes.string,
	buildUrl: PropTypes.func.isRequired
};

export default HighlightDefault;
